import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PartnerSlider = () => {
    const settings = {
        className: "center",
        centerMode: true,
        dots: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerPadding: "-50px"
                }
            }
        ]
    };

    return (
        <Slider {...settings} className='partners'>
            <a href='https://www.brennseehof.com/de' target='_blank' rel="noreferrer">
                <img src='/partners/alte-post.png' alt='altepost-logo'/>
            </a>
            <a href='https://www.context-online.at/' target='_blank' rel="noreferrer">
                <img src='/partners/context.png' alt='context-logo'/>
            </a>
            <a href='https://www.sonnenhotels.de/hotels-resorts/maltschacher-see/hotel/sonnenresort-ossiacher-see' target='_blank' rel="noreferrer">
                <img src='/partners/ossiachersee.png' alt='ossiachersee-logo' />
            </a>
            <a href='https://www.hlw.at/' target='_blank' rel="noreferrer">
                <img src='/partners/hlw.png' alt='hlw-logo'/>
            </a>
            <a href='https://hotelresort-klopeinersee.at/' target='_blank' rel="noreferrer">
                <img src='/partners/klopeinersee.png' alt='klopeinersee-logo'/>
            </a>
            <a href='https://www.panoramadorf-saualpe.com/' target='_blank' rel="noreferrer">
                <img src='/partners/panoramadorf.png' alt='panoramadorf-logo' />
            </a>
            <a href='https://www.brennseehof.com/de' target='_blank' rel="noreferrer">
                <img src='/partners/sonnenhotels.png' alt='sonnenhotels-logo' />
            </a>
            <a href='https://www.brennseehof.com/de' target='_blank' rel="noreferrer">
                <img src='/partners/urlaubambauernhof.png' alt='urlaubambauernhof-logo' />
            </a>
            <a href='https://pauer-elektronik.at/' target='_blank' rel="noreferrer">
                <img src='/partners/pauer.png' alt='pauer-logo' />
            </a>
            <a href='https://www.porschekaernten.at/' target='_blank' rel="noreferrer">
                <img src='/partners/porsche.png' alt='porsche-logo' />
            </a>
            <a href='https://www.sonnenhotels.de/hotels-resorts/maltschacher-see/hotel/sonnenresort-maltschachersee' target='_blank' rel="noreferrer">
                <img src='/partners/maltschachersee.png' alt='maltschachersee-logo' />
            </a>
            <a href='https://hotel-marolt.at/' target='_blank' rel="noreferrer">
                <img src='/partners/marolt.png' alt='marolt-logo' />
            </a>
            <a href='http://www.gasthof-prettner.at/' target='_blank' rel="noreferrer">
                <img src='/partners/prettner.png' alt='prettner-logo' />
            </a>

        </Slider>
    );
};

export default PartnerSlider;